interface RootLayoutProps {
  readonly children: React.ReactNode;
}

export function RootLayout({ children }: RootLayoutProps) {
  return (
    <div className="bg-screen min-h-screen">
      <main
        className="overflow-hidden"
        style={{ height: 'calc(100vh - var(--mmt-header-height, 0px))' }}
      >
        {children}
      </main>
    </div>
  );
}
